<template>
  <div style="border:1px solid #dcdfe6;border-bottom:0;">
    <div class="app-toolbar1">
      <el-button size="mini" @click="toAdd" type="primary">添加项</el-button>
    </div>
    <el-table :data="dictionaryItems" :stripe="true" size="mini" v-loading="loading">
      <el-table-column prop="orderNo" label="序号"></el-table-column>
      <el-table-column prop="parentKey" label="父键"></el-table-column>
      <el-table-column prop="key" label="键"></el-table-column>
      <el-table-column prop="value" label="值"></el-table-column>
      <el-table-column fixed="right" label="操作" width="145">
        <template slot-scope="scope">
          <el-button @click="toUpdate(scope.row)" type="primary" size="mini" v-if="!!dictionaryId">修改</el-button>
          <el-button @click="toDelete(scope.row)" type="danger" size="mini">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="formTitle" :visible.sync="showForm" @close="resetForm" append-to-body>
      <el-form :model="form" :rules="formRule" ref="form" :status-icon="true" label-position="top">
        <el-form-item label="父键" prop="parentKey">
          <el-input v-model="form.parentKey" placeholder="请输入父键"></el-input>
        </el-form-item>
        <el-form-item label="键" prop="key">
          <el-input v-model="form.key" placeholder="请输入键"></el-input>
        </el-form-item>
        <el-form-item label="值" prop="value">
          <el-input v-model="form.value" placeholder="请输入值"></el-input>
        </el-form-item>
        <el-form-item label="序号" prop="orderNo">
          <el-input v-model="form.orderNo" placeholder="序号"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showForm = false">取 消</el-button>
        <el-button type="primary" @click="doSave(true)">保 存</el-button>
        <el-button type="primary" @click="doSave(false)" v-if="!this.form.dictionaryItemId">保存并继续</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'dictionary-item-manage',
  props: {
    dictionaryId: { type: Number, required: false }
  },
  data () {
    return {
      loading: false,
      dictionaryItems: [],
      showForm: false,
      formTitle: '添加字典项',
      form: {
        dictionaryItemId: 0,
        parentKey: '',
        key: '',
        value: '',
        orderNo: 0
      },
      formRule: {
        key: [{ required: true, message: '请输入键', trigger: 'blur' }],
        value: [{ required: true, message: '请输入值', trigger: 'blur' }],
        orderNo: [{ required: true, message: '请输入序号', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.load()
  },
  watch: {
    dictionaryId () {
      this.load()
    }
  },
  methods: {
    load () {
      let dictionaryId = this.dictionaryId
      if (!dictionaryId) {
        this.dictionaryItems = []
        return
      }

      this.loading = true
      this.$http.request({
        method: 'get',
        url: `/api/cgDictionaries/${dictionaryId}/items`
      }).then((res) => {
        this.dictionaryItems = res.data.data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    toAdd () {
      this.formTitle = '添加字典项'
      this.form = { dictionaryItemId: 0, parentKey: '', key: '', value: '', orderNo: 0 }
      this.showForm = true
    },
    toUpdate (row) {
      this.formTitle = '修改字典项'
      this.form = { dictionaryItemId: row.dictionaryItemId, parentKey: row.parentKey, key: row.key, value: row.value, orderNo: row.orderNo }
      this.showForm = true
    },
    toDelete (row) {
      if (row.dictionaryItemId) {
        this.$store.commit('confirm', { title: '提示', msg: '您确认要删除该字典项吗?', data: row, scope: this, callback: this.doDelete })
      } else {
        let dictionaryItems = this.dictionaryItems
        for (let i = 0; i < dictionaryItems.length; i++) {
          if (row === dictionaryItems[i]) {
            dictionaryItems.splice(i, 1)
            return
          }
        }
      }
    },
    doSave (close) {
      this.$refs.form.validate((success) => {
        if (success) {
          let dictionaryId = this.dictionaryId
          if (dictionaryId) {
            let dictionaryItemId = this.form.dictionaryItemId
            this.$http.request({
              method: dictionaryItemId === 0 ? 'post' : 'put',
              url: dictionaryItemId === 0 ? `/api/cgDictionaries/${dictionaryId}/items` : `/api/cgDictionaries/${dictionaryId}/items/${dictionaryItemId}`,
              data: JSON.stringify({
                parentKey: this.form.parentKey,
                key: this.form.key,
                value: this.form.value,
                orderNo: this.form.orderNo
              })
            }).then(() => {
              if (close) {
                this.showForm = false
              } else {
                if (!dictionaryItemId) {
                  this.form = { dictionaryItemId: 0, parentKey: '', key: '', value: '', orderNo: 0 }
                  this.$refs.form.resetFields()
                }
              }
              this.load()
            })
          } else {
            this.dictionaryItems.push({ parentKey: this.form.parentKey, key: this.form.key, value: this.form.value, orderNo: this.form.orderNo })
            if (close) {
              this.showForm = false
            } else {
              this.form = { dictionaryItemId: 0, parentKey: '', key: '', value: '', orderNo: 0 }
              this.$refs.form.resetFields()
            }
          }
        } else {
          return false
        }
      })
    },
    doDelete (result, data) {
      if (result) {
        this.$http.request({
          method: 'delete',
          url: `/api/cgDictionaries/${this.dictionaryId}/items/${data.dictionaryItemId}`
        }).then(() => {
          this.$message.success('删除成功')
          this.load()
        })
      }
    },
    getItems () {
      return this.dictionaryItems
    },
    resetForm () {
      this.$refs.form.resetFields()
    }
  }
}
</script>
